import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-02.png';
import icn_02 from '../../assets/img/landingPage/composable/icn_composable_02.png';
import icn_03 from '../../assets/img/landingPage/composable/icn_composable_03.png';
import icn_04 from '../../assets/img/landingPage/composable/icn_composable_04.png';
import icn_05 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-02.png';



import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import avap from '../../assets/img/landingPage/composable/AVAP_Lenguaje-negativo.svg';
import vs from '../../assets/img/landingPage/composable/AVAP_VS-negativo.svg';
import connector from '../../assets/img/landingPage/composable/AVAP_Connector-negativo.svg';
import framework from '../../assets/img/landingPage/composable/AVAP_Framework-negativo.svg';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/modeling/a2ml-01.png';


const ComposableBusiness = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'AVAP Language',
            text: "Define APIs and microservices with declarative logic, built for reuse.",
            altDescription: "Define APIs and microservices with declarative logic, built for reuse.",
            image: avap,
        },
        Key_Feature_02: {
            title: "AVAP Virtual Server + Mesh Manager",
            text: "Deploy, route, and orchestrate modular components across distributed environments.",
            altDescription: "Deploy, route, and orchestrate modular components across distributed environments.",
            image: vs,
        },
        Key_Feature_03: {
            title: 'Native Connectors',
            text: 
            "Ensure seamless integration with external platforms, SaaS tools, and legacy systems.",
            altDescription: 'Design workflows where human input meets AI action.',
            image: connector,
        },
        Key_Feature_04: {
            title: 'Built-in Lifecycle Management',
            text: 
            "Design, test, version, secure, and monitor APIs, all within one cohesive environment.",
            altDescription: 'Design, test, version, secure, and monitor APIs—all within one cohesive environment.',
            image: framework,
        },
    }

    //Key UseCases Bento
    const items2 = [
        {
            icon: icn_01,
            title: 'Public Sector',
            paragraphs: [
              'Launch new digital offerings by composing from existing microservices.'
            ]
          },
        {
            icon: icn_02,
            title: 'Enterprises',
            paragraphs: [
              'Deliver audit-ready, compliant API governance without extra complexity.'
            ]
          },
        {
          icon: icn_03,
          title: 'Innovation Teams',
          paragraphs: [
            'Rapidly prototype and deploy modular capabilities.',
          ]
        },
        {
            icon: icn_04,
            title: 'Modernization Projects',
            paragraphs: [
              'Migrate from monolithic architectures to flexible, API-first systems.',
            ]
          },         
      ];
      
    const breakpointColumnsObj2 = {
        default: 4, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };
    
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-2">
                    <h1 className="fl-title-big m-0">Composable Business with AVAP</h1>
                    <p className="fl-title m-0 gradient-text">Modular by design. Scalable by default.</p>
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-0"
                        style={{ width: '44%', maxWidth: '800px', height: 'auto' }}
                    />
                        <br />
                        <h2 className='fl-subtitle pt-8'>Unlock the Power of Composable Architecture</h2>
                                <p className="fl-text fl-txt-container-s" >
                                Composable Business is more than a trend, it’s a transformative model for building agile, resilient digital organizations. By designing your enterprise around modular, reusable components like APIs, microservices, and workflows, you can adapt to change faster, reduce technical debt, and scale with confidence.
                                </p>
                                <p className="fl-text fl-txt-container-s" >
                                AVAP Framework was engineered from the ground up to support composable thinking, turning complexity into structured, flexible architecture.

                                </p>
                                {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                </section>

                  
                <div className="container text-center fl-card-border p-6">
                    <h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why Composable Business?</h2>
                    <br/>
                    <p className="fl-subtitle"><p/> 
                    {/* Sección Bullets */}
                    <ul className="fl-text fl-txt-container-s">
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> Maximum modularity:</strong> Design systems from interchangeable components (APIs, services, automations).</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> Dynamic orchestration:</strong> Assemble business capabilities in real time to meet evolving needs.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> Interoperability by default:</strong> Connect legacy and modern systems through standardized APIs and events.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> Evolutive scalability:</strong> Update, replace, or scale components without disrupting the whole stack.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}> Continuous innovation:</strong> Launch new services faster by reusing what already works.</li> </ul>
                    </p>
                </div>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">What Makes AVAP Composable-Ready?</p> 
                            <p className='pt-3'>AVAP Framework provides the full toolkit to architect composable systems:</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6 text-center">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    style={{ height: '120px', width: 'auto' }}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                            </div>
                        </section>
                    </div>
                </div>

               {/* Sección Key Use Cases */}   
              {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                            Key Use Cases
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Public Sector:
                                </p>
                                <p className="fl-text">
                                Automate complex services (e.g., identity verification, benefit disbursement) using reusable API workflows.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Enterprises:
                                </p>
                                <p className="fl-text">
                                Launch new digital offerings by composing from existing microservices.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Innovation Teams:
                                </p>
                                <p className="fl-text">
                                Rapidly prototype and deploy modular capabilities.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Modernization Projects:
                                </p>
                                <p className="fl-text">
                                Migrate from monolithic architectures to flexible, API-first systems.
                                </p>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/*Sección Use Cases - bento */}
                <div className="container my-5">
                <div className="fl-title text-center mb-6">
                 Key Use Cases
                </div>
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item2, idx) => (
                        <div key={idx} className="grayBox fl-card text-center">
                        <img src={item2.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item2.title}</p>
                        {item2.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>
                
                {/* leyenda */} 
                <section className="container py-10">
                    <h1 className='fl-subtitle text-center  gradient-text'>"Composable architecture lets you adapt as fast as your environment changes. AVAP gives you the control, speed, and structure to make it happen."</h1>
                </section>

                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="text-center">
                                    <h3 className='fl-title'>Built for Enterprise Transformation</h3>
                                    <p>AVAP aligns with the architectural vision championed by Gartner, Salesforce, Oracle, and others, bringing those capabilities within reach for businesses of any size.
                                    </p>
                                    <br/>
                                    <p className='bold'>Compose. Deploy. Scale with AVAP.
                                    </p>
                                {/*Boton Contact Us*/}  
                                <a className="glowBtn-dark " 
                                    style={{ zIndex: 2, }} 
                                    href="/contact" 
                                    target='_blank'><span className="btnInner">Contact Us</span></a> 
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default ComposableBusiness;
